import { LOCALSTORAGE_KEY, getLocalStorageCurrency } from "@config";
import type { HttpRequestConfig } from "@kalodata/http";
import { initPageLanguage } from "@utils/util";

export const applyLegacyRequestHeaders = <TMeta = unknown, TContext = unknown>(
  request: HttpRequestConfig<unknown, TMeta, TContext>,
): HttpRequestConfig<unknown, TMeta, TContext> => {
  const language = localStorage.getItem(LOCALSTORAGE_KEY.LANGUAGE) || initPageLanguage();
  const country = localStorage.getItem(LOCALSTORAGE_KEY.REGION) || "US";
  const currency = getLocalStorageCurrency();

  return {
    ...request,
    headers: {
      ...request.headers,
      language,
      country,
      currency,
    },
  };
};
